import{useRoutingContext as e}from"../context/RoutingContext.js";function t(){const{router:t}=e();return{push:t.push,replace:t.replace,pathname:t.pathname,query:t.query}}export{t as useLocation};
//# sourceMappingURL=use-location.js.map
